import React from 'react'
import { Col, Collapse, Row, Table, Tabs, Radio, Carousel } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../../containers/Container";
import BaoCaoDinhKy from './BaoCaoDinhKy/index'
import ViTriQuanTrac from './ViTriQuanTrac/index'
import BieuDo_BCDK from '../../../../components/License/BieuDo/index'
const { Panel } = Collapse;
const { TabPane } = Tabs;
class DischargeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      changeBieudo: 1,
    }
  }

  componentDidMount() {

  }
  render() {
    const { idGiayPhep, selectedRow, editable, handleMap } = this.props;
    const { changeBieudo } = this.state
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <Container>
        <Tabs type="card" style={{ width: "100%" }}>
          <TabPane tab="Báo cáo định kỳ" key="2">
            <Row type='flex' justify='end'>
              <Radio.Group name="radiogroup" defaultValue={1} >
                <Radio style={radioStyle} value={1} onChange={(e) => e.target.value === 1 && this.setState({ changeBieudo: 1 })}>Danh sách</Radio>
                <Radio style={radioStyle} value={2} onChange={(e) => e.target.value === 2 && this.setState({ changeBieudo: 2 })}>Biểu đồ</Radio>
              </Radio.Group>
            </Row>

            <div className="mt-20"></div>
            <div style={{ minHeight: 500 }}>
              {changeBieudo === 1 &&
                <BaoCaoDinhKy
                  idGiayPhep={idGiayPhep}
                  data_giayphep={selectedRow}
                  editable={editable}
                />}
              {changeBieudo === 2 &&
                <BieuDo_BCDK
                  idGiayPhep={idGiayPhep}
                />
              }
            </div>
          </TabPane>
          <TabPane tab="Vị trí quan trắc" key="3">
            <ViTriQuanTrac
              idGiayPhep={idGiayPhep}
              data_giayphep={selectedRow}
              editable={editable}
              handleMap={handleMap}
            />
          </TabPane>
        </Tabs>
      </Container>
    )
  }
}

DischargeDetail.propTypes = {
  idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(DischargeDetail)